export default __webpack_public_path__ + "static/media/eight-strip.2e5f002d.png";